<template>
  <BaseElSelect
    v-model="syncModel"
    v-bind="$attrs"
    :multiple="multiple"
    value-key="id"
    collapse-tags
    :filterable="false"
    :disabled="disabled"
    :placeholder="$t('reservationNotspecifySettings.notSpecifyUnits.placeholder')"
    :no-data-text="$t('common.table.empty.text')"
    @change="onChange"
  >
    <BaseElSelectOption
      v-for="item in displayOptions"
      :key="item.id"
      :label="staleOptionLabel(item.name, optionStaleReason(item))"
      :disabled="Boolean(optionStaleReason(item))"
      :value="item"
    />
  </BaseElSelect>
</template>

<script>
import { GetServiceUnit, GetServiceUnitCount } from '@/api/serviceUnit'
import { mapGetters } from 'vuex'
import {
  optionStaleReason,
  staleOptionLabel,
  withPreservedOption,
} from '@/use/useReservationStaleField'

export default {
  name: 'ServiceUnitSelect',
  props: [
    'model',
    'multiple',
    'disabled',
    // CBGISSUE-243：已失效（例如已被刪除）的服務人員若仍是既有預約的歷史快照，
    // 由外部傳入失效原因，保留顯示並加註原因，而不是讓欄位無聲變空白
    'staleReason',
  ],
  computed: {
    ...mapGetters([
      'shop',
    ]),
    displayOptions () {
      return withPreservedOption(this.serviceUnitList, this.model, this.multiple ? null : this.staleReason)
    },
    syncModel: {
      get () {
        return this.model
      },
      set (data) {
        this.$emit('update:model', data)
      },
    },
  },

  data: () => ({
    serviceUnitList: [],
  }),

  async mounted () {
    await this.getServiceUnit()
  },

  methods: {
    staleOptionLabel,
    optionStaleReason,
    onChange (unit) {
      this.$emit('change', unit)
    },
    //= > 取得服務人員
    async getServiceUnit () {
      try {
        const count = await this.getServiceUnitCount()
        const config = {
          shopId: this.shop,
          start: 0,
          limit: 100,
        }

        const res = await GetServiceUnit(config)
        this.serviceUnitList = res

        while (this.serviceUnitList.length < count) {
          config.start += config.limit
          const data = await GetServiceUnit(config)
          this.serviceUnitList.push(...data)
          console.log('serviceUnitList', this.serviceUnitList.length)
        }
      } catch (error) {
        console.log(error)
        this.$message.error('取得服務失敗')
      }
    },

    //= > 取得服務人員總數
    async getServiceUnitCount () {
      try {
        return await GetServiceUnitCount({ shopId: this.shop })
      } catch (error) {
        console.log(error)
        this.$message.error('取得服務總數失敗')
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
